import { useCallback } from 'react';
import { useTemplateEditorDispatch } from '../context/UseTemplateEditorContext';
import {
  IOffsiteTemplatePreviewResponse,
  OnsiteTemplatePreviewQueryResponse,
} from 'sections/design/template-management/entities/templates';

export const useSetEnrichmentsContext = (
  response: IOffsiteTemplatePreviewResponse | OnsiteTemplatePreviewQueryResponse,
) => {
  const dispatch = useTemplateEditorDispatch();

  return useCallback(() => {
    const { enrichments } = response as IOffsiteTemplatePreviewResponse;

    if (!enrichments) {
      return;
    }

    dispatch({
      type: 'SET_ENRICHED_COMPILATION_CONTEXT',
      payload: enrichments,
    });
  }, [dispatch, response]);
};
